import Vue from 'vue'

export const setGrpr = (state, payload) => {
  Vue.set(state, 'grpr', payload)
}

export const setLoadingParcelamento = (state, payload) => {
  Vue.set(state, 'loadingParcelamento', payload)
}
